import { render, staticRenderFns } from "./gj-input.vue?vue&type=template&id=6f104914&scoped=true&"
import script from "./gj-input.vue?vue&type=script&lang=js&"
export * from "./gj-input.vue?vue&type=script&lang=js&"
import style0 from "./gj-input.vue?vue&type=style&index=0&id=6f104914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f104914",
  null
  
)

export default component.exports